import { Swiper } from "swiper";
import { EffectFade, Pagination, Navigation, Autoplay, Scrollbar  } from 'swiper/modules';

if(document.getElementById("gdiSwiper")) {
  const swiper = new Swiper('#gdiSwiper', {
    modules: [ Pagination, EffectFade, Navigation, Autoplay],
    direction: 'horizontal',
    loop: true,
    effect: "swipe",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: "fraction",
    },
    navigation: {
      nextEl: '.facts-swiper-button-next',
      prevEl: '.facts-swiper-button-prev',
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
    },
    speed: 1200,
    slidesPerView: 1,
  });
  swiper.autoplay.start();
}

document.querySelectorAll('.home-swiper').forEach((slider) => {

  const slidesNo = Number(slider.dataset.slideNo) || 3;

  new Swiper(slider, {
      modules: [Pagination, Navigation, Scrollbar],

      loop: false,
      speed: 800,
      effect: 'slide',
      slidesPerView: 1,
      spaceBetween: 20,

      breakpoints: {
        500: {
          slidesPerView: 1,
      },
          640: {
              slidesPerView: 2,
          },
          768: {
              slidesPerView: slidesNo,
          }
      },

      pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'fraction',
      },

      navigation: {
          nextEl: slider.querySelector('.home-swiper-button-next'),
          prevEl: slider.querySelector('.home-swiper-button-prev'),
      },

      scrollbar: {
          el: slider.querySelector('.swiper-scrollbar'),
          draggable: true,
      }
  });

});
